import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAnimationShownCount, getChatAnimationCounter, getPrevPathCookie } from '../utils/chatAnimationCounter';
import {
  incrementAnimationCounter,
  setAnimationShownCount,
  setChatAnimationCounter,
} from 'shared/actions/consultantCianChat';
import {
  animationDelayMsSelector,
  animationShownCountSelector,
  chatAnimationCounterSelector,
} from 'shared/selectors/consultantCianChat';
import { TThunkDispatch } from 'shared/types/redux';

export const useChatAnimationCounter = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const animationDelayMs = useSelector(animationDelayMsSelector);
  const counter = useSelector(chatAnimationCounterSelector);
  const animationShownCount = useSelector(animationShownCountSelector);

  const [shouldShowAnimation, setShouldShowAnimation] = React.useState(false);

  React.useEffect(() => {
    const cookieCounter = getChatAnimationCounter();
    const cookieAnimationShownCount = getAnimationShownCount();
    dispatch(setChatAnimationCounter(cookieCounter));
    dispatch(setAnimationShownCount(cookieAnimationShownCount));
    const currentPath = window.location.pathname + window.location.search;
    const prevPath = getPrevPathCookie();

    if (prevPath !== currentPath) {
      dispatch(incrementAnimationCounter());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!animationShownCount || counter - animationShownCount >= 5) {
      setShouldShowAnimation(true);
    } else {
      setShouldShowAnimation(false);
    }
  }, [counter, animationShownCount, dispatch]);

  const incrementAnimationShownCounter = React.useCallback(() => {
    dispatch(setAnimationShownCount(counter));
  }, [counter, dispatch]);

  return { counter, shouldShowAnimation, incrementAnimationCounter, animationDelayMs, incrementAnimationShownCounter };
};
